import bulkSelect from './bulk-select.module';
export default bulkSelect;
